import { Store } from "../lib";
import { Variant } from "../models";
import moment from "moment";
export default class VariantsStore extends Store {
  model = Variant;
  baseWebURI = "/app/inventory/variants";

  searchStock(id, params) {
    let fetchParams = Object.assign({}, params);

    return this.fetch(`${id}/stocks`, fetchParams);
  }

  searchImages(id, params) {
    let fetchParams = Object.assign({}, params);

    return this.fetch(`${id}/images`, fetchParams);
  }

  export(variant_ids, company) {
    return this.appStore.coreAPIClient.post("/variants/export", {
      in_list: variant_ids,
    });
  }

  fetchVariantByExternalRef(reference, type) {
    return this.appStore.coreAPIClient.search(
      `/variants/?reference=${reference}&type=${type}`
    );
  }

  update(id, params) {
    return this.appStore.coreAPIClient.sendRequest(
      `/variants/${id}`,
      "PUT",
      params
    );
  }

  getImages(id) {
    return this.appStore.coreAPIClient.sendRequest(
      `/variants/${id}/images`,
      "GET"
    );
  }

  archive(variant) {
    const params = {
      id: variant.id,
      archived: !variant.archived,
    };

    return this.appStore.coreAPIClient.put(`/variants`, params).then((res) => {
      if (res && res["results"]) {
        variant.set(res["results"]);
        variant.endUpdate();
      }
    });
  }

  getStockUnits(variantId, filters) {
    const _filters = {
      sort: "expiration_date",
      order: "asc",
      ...filters,
    };
    const searchString = new URLSearchParams(_filters);
    return this.appStore.coreAPIClient
      .sendRequest(`/variants/${variantId}/stock_units?${searchString}`, "GET")
      .then((res) => {
        return res.results.map((item) => {
          const expirationDate = item.expiration_date
            ? moment(item.expiration_date)
            : null;

          const currentDate = moment();

          const expired = expirationDate ? expirationDate < currentDate : false;

          const dateWarning = expirationDate
            ? (expirationDate - currentDate) / (1000 * 60 * 60 * 24) <= 60 &&
              expirationDate - currentDate >= 0
            : false;

          return {
            ...item,
            expired,
            dateWarning,
          };
        });
      });
  }
}
